<template>
  <div>
    <nav-bar />
    <b-container fluid>
      <b-row>
        <b-col>
          <b-overlay :show="loading">
            <v-card>
              <v-card-title>
                <b-row no-gutters align-v="center">
                  <b-col>PERFIS DE USUÁRIO</b-col>
                  <b-col cols="auto">
                    <v-btn text color="primary" @click="newUserProfile">
                      <v-icon> mdi-plus </v-icon>
                      NOVO
                    </v-btn>
                  </b-col>
                </b-row>
              </v-card-title>
              <v-card-text>
                <!-- PERFIS DE USUÁRIO -->
                <v-expansion-panels flat v-model="open">
                  <v-expansion-panel
                    v-for="(user_profile, user_profile_index) in user_profiles"
                    :key="`${user_profile_index}`"
                  >
                    <v-expansion-panel-header
                      :disable-icon-rotate="user_profile.hasError"
                    >
                      <template v-if="user_profile.hasError" #actions>
                        <v-icon color="error"> mdi-alert-circle </v-icon>
                      </template>
                      <h4>PERFIL DE USUÁRIO: {{ user_profile.name }}</h4>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <b-row align-v="center">
                        <b-col cols="auto">
                          <v-btn
                            icon
                            color="red"
                            @click="delUserProfile(user_profile_index)"
                          >
                            <v-icon>mdi-trash-can</v-icon>
                          </v-btn>
                        </b-col>
                        <b-col cols="auto">
                          <v-btn
                            :disabled="user_profile_index === 0"
                            icon
                            @click="
                              user_profiles = arraySwapItemPosition(
                                user_profiles,
                                user_profile_index,
                                user_profile_index - 1
                              )
                            "
                          >
                            <v-icon> mdi-arrow-up </v-icon>
                          </v-btn>
                          <v-btn
                            :disabled="
                              user_profile_index === user_profiles.length - 1
                            "
                            icon
                            @click="
                              user_profiles = arraySwapItemPosition(
                                user_profiles,
                                user_profile_index,
                                user_profile_index + 1
                              )
                            "
                          >
                            <v-icon> mdi-arrow-down </v-icon>
                          </v-btn>
                        </b-col>
                        <b-col cols="6">
                          <v-text-field
                            dense
                            outlined
                            hide-details
                            label="NOME"
                            v-model="user_profile.name"
                          >
                          </v-text-field>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <h5>PERMISSÕES</h5>
                          <v-expansion-panels flat>
                            <v-expansion-panel
                              v-for="permission_group in permission_groups.filter(
                                (group) => group.permissions > 0
                              )"
                              :key="permission_group.id"
                            >
                              <v-expansion-panel-header>
                                <h5 class="my-0">
                                  {{ permission_group.name }}
                                </h5>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-data-iterator
                                  :items="
                                    permissions.filter(
                                      (permission) =>
                                        permission.group_id ==
                                        permission_group.id
                                    )
                                  "
                                >
                                  <template #no-data>
                                    NENHUMA PERMISSÃO NESTE GRUPO
                                  </template>
                                  <template #item="{ item }">
                                    <div class="p-4 mb-2 permission">
                                      <h6>{{ item.name }}</h6>
                                      <p v-if="item.description">
                                        {{ item.description }}
                                      </p>
                                      <b-row no-gutters>
                                        <b-col
                                          class="mr-10"
                                          cols="auto"
                                          v-for="action in item.actions"
                                          :key="action.id"
                                        >
                                          <v-checkbox
                                            dense
                                            hide-details
                                            :label="action.name"
                                            :false-value="false"
                                            :true-value="true"
                                            :input-value="
                                              permissionExists(
                                                user_profile,
                                                item.target,
                                                action.value
                                              )
                                            "
                                            @change="
                                              addAction(
                                                user_profile,
                                                item.target,
                                                action.value,
                                                $event
                                              )
                                            "
                                          >
                                          </v-checkbox>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </template>
                                </v-data-iterator>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </b-col>
                      </b-row>
                      <errors-messages :errors="user_profile.errors" />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <errors-messages :errors="errors" />
              </v-card-text>
              <v-card-actions>
                <b-row no-gutters align-h="end">
                  <b-col cols="auto">
                    <v-btn text color="green" @click="validate">
                      <v-icon> mdi-check </v-icon>
                      SALVAR
                    </v-btn>
                  </b-col>
                </b-row>
              </v-card-actions>
            </v-card>
          </b-overlay>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import api from "../services/api";
import NavBar from "../templates/NavBar.vue";
import { arraySwapItemPosition } from "../lib/functions";
import { validateString } from "../lib/validate";
import ErrorsMessages from "../templates/components/ErrorsMessages.vue";
import toast from "../components/ToastNotification";

export default {
  name: "RestHomeUserProfiles",

  components: { NavBar, ErrorsMessages },

  data() {
    return {
      open: null,
      errors: [],
      loading: false,

      permission_groups: [],
      permissions: [],

      /**
       * @type {{
       *   name: string,
       *   errors: string[],
       *   hasError: boolean,
       *   permissions: {
       *     target: string,
       *     action: string,
       *   }[],
       * }[]}
       */
      user_profiles: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    arraySwapItemPosition,

    async retrieve() {
      if (this.errors.length === 0) await this.getPermissionGroups();
      if (this.errors.length === 0) await this.getPermissions();
      if (this.errors.length === 0) await this.getUserProfiles();
    },

    async getPermissionGroups() {
      try {
        this.loading = true;

        const response = await api.get(
          "/admin/rest-home/default/permission/groups"
        );
        const { error, errors, groups } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.permission_groups = groups;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async getPermissions() {
      try {
        this.loading = true;

        const response = await api.get("/admin/rest-home/default/permissions");
        const { error, errors, permissions } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.permissions = permissions;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    newUserProfile() {
      this.user_profiles.push({
        name: "",
        description: "",
        errors: [],
        categories: [],
        permissions: [],
      });
    },

    delUserProfile(user_profile_index) {
      this.user_profiles.splice(user_profile_index, 1);
      this.validate();
    },

    addAction(user_profile, target, action, value) {
      let index = user_profile.permissions.findIndex(
        (item) => item.target === target && item.action === action
      );

      if (value) {
        if (index > -1) {
          return;
        } else {
          const READ_EXISTS = user_profile.permissions.some(
            (item) => item.target === target && item.action === "READ"
          );

          if (action !== "READ" && !READ_EXISTS) {
            user_profile.permissions.push({ target, action: "READ" });
          }
          user_profile.permissions.push({ target, action });
        }
      } else {
        if (action === "READ") {
          while (index > -1) {
            user_profile.permissions.splice(index, 1);

            index = user_profile.permissions.findIndex(
              (item) => item.target === target
            );
          }
        } else if (index > -1) user_profile.permissions.splice(index, 1);
      }
    },

    permissionExists(user_profile, target, action) {
      return user_profile.permissions.some(
        (permission) =>
          permission.target === target && permission.action === action
      );
    },

    async getUserProfiles() {
      try {
        this.user_profiles = [];
        this.open = null;
        this.loading = true;

        const response = await api.get(
          "/admin/rest-home-deploy-script/user-profiles"
        );
        const { error, errors, user_profiles } = response.data;

        if (error) {
          this.errors = errors;
          this.user_profiles = [];
        } else {
          this.user_profiles = user_profiles;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async validate() {
      try {
        this.loading = true;

        //#region validação
        let valid = true;
        let reason;
        //#region perfis de usuário
        for (let user_profile of this.user_profiles) {
          user_profile.errors = [];
          user_profile.hasError = false;

          reason = validateString(user_profile.name, {
            minLength: {
              expected: 3,
              reason: "Nome deve conter ao menos 3 caracteres",
            },
            maxLength: {
              expected: 64,
              reason: "Nome deve conter até 64 caracteres",
            },
          });
          if (reason) user_profile.errors.push(reason);

          if (user_profile.errors.length > 0) {
            user_profile.hasError = true;
            valid = false;
          }
        }
        //#endregion

        if (!valid) {
          this.loading = false;
          return;
        }
        //#endregion

        const data = { user_profiles: this.user_profiles };
        const response = await api.patch(
          "/admin/rest-home-deploy-script/user-profiles",
          data
        );
        const { error, errors, message, user_profiles } = response.data;

        if (error) {
          this.errors = errors;
          if (user_profiles) this.user_profiles = user_profiles;
        } else {
          this.errors = [];
          this.getUserProfiles();
          toast(message, "success");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
.v-expansion-panels--flat:not(:empty) {
  border: 2px solid #f5f5f5;
}

.v-expansion-panel--active:not(:first-child) {
  border-top: 2px solid #f5f5f5;
}

.v-expansion-panel--active:not(:last-child) {
  border-bottom: 2px solid #f5f5f5;
}

.v-input--checkbox {
  margin: 0;
}

.v-input--checkbox label {
  margin: 0;
}

.permission {
  background-color: #f5f5f5;
}

.permission:last-child {
  margin-bottom: 0;
}
</style>